module.exports = __webpack_public_path__ + "img/banner01.75c46f33.webp";